// returns promotion name based on provided id from promtions list
export const getPromotionName = (promotionId, promotionsList) => {
	const promotion = promotionsList.find(({ value }) => value === promotionId);

	return promotion ? { name: promotion.name, value: promotion.value } : '';
};
